import defaults from 'lodash/defaults';
import filter from 'lodash/fp/filter';
import flow from 'lodash/fp/flow';
import forEach from 'lodash/fp/forEach';
import get from 'lodash/fp/get';
import keyBy from 'lodash/fp/keyBy';
import map from 'lodash/fp/map';
import orderBy from 'lodash/fp/orderBy';
import thru from 'lodash/fp/thru';

export function createCategoriesTree(categoryResults) {
  const nodes = {};

  return flow([
    get('data'),
    orderBy(['rank'], ['asc']),
    map((category) => ({
      parentId: category.parentId,
      title: category.name,
      tags: category.tags,
      value: category.id,
      key: category.id,
    })),
    thru(
      forEach((category) => {
        nodes[category.key] = defaults(category, nodes[category.key], {children: []});
        nodes[category.parentId] = defaults(nodes[category.parentId], {children: []});

        if (nodes[category.parentId] !== category) {
          nodes[category.parentId].children.push(category);
        }
      }),
    ),
    filter((category) => !category.parentId),
  ])(categoryResults);
}

export function buildCategoryDict(categoriesResult) {
  return flow([
    get('data'),
    map((data) => {
      data.value = data.id;
      return data;
    }),
    keyBy('id'),
  ])(categoriesResult);
}

export function parseApiResult(categoriesResult) {
  const categoriesTree = createCategoriesTree(categoriesResult);
  const parentCategories = categoriesResult?.data?.filter((category) => category?.parentId === undefined);
  const topLevelCategories = createCategoriesTree({data: parentCategories});

  const categoryDict = buildCategoryDict(categoriesResult);

  return {
    categoriesTree,
    topLevelCategories,
    dict: categoryDict,
  };
}

/**
 * Returns the string name (title) corresponding to the
 * category found in the dictionary with the provided id.
 *
 * @param categoryDict
 * @param categoryId
 * @returns {*}
 */
export function getCategoryName(categoryDict, categoryId) {
  return categoryDict?.[categoryId]?.name;
}
